/**
 * @Note
 * Function to ensure that you submit an empty array if all the keys of the objects within the array are empty.
 * This function validates each object and returns a filtered array, removing the objects that are completely empty.
 *
 * If all objects are removed, the submitted array will be empty.
 *
 */

const filterDependents = (dependents) => {
  return dependents.filter((dependent) => {
    return !Object.values(dependent).every(
      (value) => value === '' || value === null || value === undefined
    );
  });
};

export { filterDependents };
